import React from 'react';
import { PRIVACY, TERMS } from '../../constants/routes';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FooterLinks = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex font-size-12">
      <Link to={TERMS} className="mx-1">
        {t('terms_of_services')}
      </Link>
      {t("and")}
      <Link to={PRIVACY} className="mx-1 ">
        {t('privacy_policy')}
      </Link>
    </div>
  );
};

export default FooterLinks;
